<template>
  <div class="row" :class="[visible ? 'visible' : 'hidden']">
    <div class="col s12 offset-m1 m10 offset-l3 l6">
      <h3 class="logout-header">Sikeres kijelentkezés</h3>
      <p v-if="loginUrlDefined">
        Sikeres kijelentkezés minden <b>Identity Platform</b> rendszerrel kapcsolatos szolgáltatásból.
        <br />
        <br />
        {{clientDisplayNameArticle | capitalize }} <span class="client-display-name"><b>{{clientDisplayName}}</b></span> szolgáltatásba való újboli bejelentkezéshez kattintson az alábbi linkre:
        <span class="link-row"><a :href="loginUrl">Bejelentkezés {{clientDisplayNameArticle}} {{clientDisplayName}} szolgáltatásba</a></span>
      </p>
      <p v-else>
        Újbóli bejelentkezéshez látogassa meg a <a v-link="{path: '/login'}">bejelentkezés</a> oldalt!
      </p>
    </div>
  </div>
</template>

<script>
import {get} from '../../api'
import {getArticle} from '../../utils'

export default {
  data() {
    return {
      visible: false,
      loginUrl: null,
      clientDisplayName: null,
      clientDisplayNameArticle: null
    }
  },
  ready() {
    this.init()
  },
  computed: {
    loginUrlDefined() {
      return Boolean(this.loginUrl)
    }
  },
  methods: {
    init() {
      const clientId = this.$route.query.client
      if (clientId) {
        try {
          get(`/public/ajax/client/${clientId}`, (clientResponse) => {
            if (clientResponse.status === 'ok' && clientResponse.loginUrl) {
              this.loginUrl = clientResponse.loginUrl
              const displayName = clientResponse.displayName
              this.clientDisplayName = displayName
              this.clientDisplayNameArticle = getArticle(displayName)
            }
            this.visible = true
          })
        } catch (err) {
          console.log('Error while getting client info.', err)
          this.visible = true
        }
      } else {
        this.visible = true
      }
    }
  }
}
</script>
<style>
  .logout-header {
    margin-bottom: 5px;
  }
  .client-display-name {

  }
  .link-row a {
    margin-top: 4px;
    display: block;
    font-weight: bold;
  }

  .visible {
    visibility: visible;
  }
  .hidden {
    visibility: hidden;
  }
</style>



// WEBPACK FOOTER //
// Logout.vue?d1016212